import React from 'react';
import styles from './KpiCard.module.css';

/**
 * KpiCard — presentational component for scalar metrics.
 *
 * Props:
 *   entry    {object}  — registry entry (label, formatFn, cardType)
 *   cardData {object}  — { value, delta, secondary }
 *   metricId {string}  — string key from registry
 */
const KpiCard = ({ entry, cardData, metricId }) => {
  // cardData may be a plain number (scalar) or an object { value, delta, secondary }
  const isScalar = typeof cardData !== 'object' || cardData === null;
  const rawValue = isScalar ? cardData : cardData.value;
  const delta = isScalar ? null : cardData.delta;
  const secondary = isScalar ? undefined : cardData.secondary;

  const formattedValue =
    entry.formatFn ? entry.formatFn(rawValue) : String(rawValue);

  let trendContent;
  let trendClass;

  if (delta === null || delta === undefined) {
    trendContent = '\u2014'; // em dash
    trendClass = styles.neutral;
  } else if (delta >= 0) {
    trendContent = '\u2191 ' + delta.toFixed(1) + '%'; // up arrow
    trendClass = styles.positive;
  } else {
    trendContent = '\u2193 ' + Math.abs(delta).toFixed(1) + '%'; // down arrow
    trendClass = styles.negative;
  }

  return (
    <div className={styles.card} data-testid={`kpi-card-${metricId}`}>
      <div className={styles.value}>{formattedValue}</div>
      <div className={styles.label}>{entry.label}</div>
      <span className={trendClass}>{trendContent}</span>
      {secondary !== undefined && secondary !== null && (
        <div className={styles.secondary}>{entry.formatFn ? entry.formatFn(secondary) : String(secondary)}</div>
      )}
    </div>
  );
};

export default KpiCard;
